var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21375",
    "data-name": "Group 21375",
    transform: "translate(1431 14123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11474",
    "data-name": "Rectangle 11474",
    width: 50,
    height: 50,
    transform: "translate(-1431 -14123)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tick",
    d: "M72,48A24,24,0,1,0,96,72,24,24,0,0,0,72,48ZM68.3,80.5a1.591,1.591,0,0,1-1.015.508,1.664,1.664,0,0,1-1.027-.519l-6.462-6.462,2.054-2.054,5.446,5.446,14.4-14.5,2.019,2.088Z",
    transform: "translate(-1478 -14170)",
    fill: "#1abf73"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.e5663972f1919577c51dc3eefe52c086.svg";
export { ForwardRef as ReactComponent };